import { useCarouselSpringboardExp } from 'experiments/pen-4889_v1_hp_carousel_springboard'

import { CarouselImage } from './CarouselImage'

const brickStaggerStyle = { transform: 'translateY(-50%)' } // Creates the running bond brick/staggered layout effect

export const DoubleColumnCarouselItem = ({
  firstColumn,
  secondColumn,
  imageWidth,
  imageHeight,
}: {
  firstColumn: string
  secondColumn: string
  imageWidth: number
  imageHeight: number
}) => {
  const { inPen4889Experiment } = useCarouselSpringboardExp()
  return (
    <div
      className={`group d-flex justify-content-center ${inPen4889Experiment ? 'mc-gap-3 mc-mb-1' : 'mc-gap-5 mc-mb-3'}`}
    >
      <div>
        <CarouselImage
          className='mc-corners--md'
          key={firstColumn}
          src={firstColumn}
          width={imageWidth}
          height={imageHeight}
        />
      </div>
      <div style={brickStaggerStyle}>
        <CarouselImage
          className='mc-corners--md'
          key={secondColumn}
          src={secondColumn}
          width={imageWidth}
          height={imageHeight}
        />
      </div>
    </div>
  )
}
